"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AppConfig = {
    botFillTargetCount: 1,
};
exports.default = AppConfig;
